const errorKeyMapMixin = {
  computed: {
    castErrorKeyToLang() {
      return ({ key, error_code }) => {
        if (!key || !error_code) return;
        return this.errorLangKeyMapper(key, error_code);
      };
    },
  },
  data: function() {
    return {
      backndfieldToFieldNameMap: {
        first_name: "Usrs_first_name",
        last_name: "Usrs_last_name",
        email: "Comn_email",
        password: "Usrs_pwd",
        confirm_password: "Comn_confirm_pwd",
        name: "Comn_country",
        phone: "Comn_mobile_num",
        type: "Comn_device_type",

        abw: "ABW_abw",
        biomass: "Comn_biomass",
        cumulative_feed: "Comn_cumu_feed",
        date: "Comn_date",
        fcr: "Comn_fcr",
        pond_id: "Comn_pond_name",
        user_type: "Comn_user_type",
        current_password: "Usrs_old_password",
      },
      backndfieldToInvalidMap: {
        first_name: { INVALID_VALUE: "Usrs_first_name_wrng_format" },
        last_name: { INVALID_VALUE: "Usrs_first_name_wrng_format" },
        email: { INVALID_VALUE: "Usrs_email_in_valid_format" },
        password: { INVALID_VALUE: "Usrs_pwd_wrng_frmt" },
        confirm_password: { INVALID_VALUE: "Usrs_pwd_cnpwd_valida" },
        name: { INVALID_VALUE: "Comn_country" },
        phone: { INVALID_VALUE: "Comn_mobile_num" },
        type: { INVALID_VALUE: "Comn_device_type" },
        abw: { INVALID_VALUE: "ABW_require" },
        biomass: { INVALID_VALUE: "Comn_biomass_require" },
        cumulative_feed: { FIELD_REQUIRED: "Comn_cumu_feed" },
        date: { FIELD_REQUIRED: "Comn_date" },
        fcr: { FIELD_REQUIRED: "Comn_fcr" },
        pond_id: { FIELD_REQUIRED: "Comn_pond_name" },
      },
    };
  },
  methods: {
    errorLangKeyMapper: function(key, error_code) {
      const fieldTranslation = this.$t(this.backndfieldToFieldNameMap[key]);
      switch (error_code) {
        case "FIELD_REQUIRED":
          return this.$t("Comn_field_is_required", { field: fieldTranslation });
        case "INVALID_VALUE":
          return this.$t(this.backndfieldToInvalidMap[key].INVALID_VALUE);
        case "NAME_ALREADY_TAKEN":
          return this.$t(this.backndfieldToInvalidMap[key][error_code]);
        case "RANGE_VALIDATION":
          return this.$t(this.backndfieldToInvalidMap[key][error_code]);
        case "PHONE_NUMBER_ALREADY_TAKEN":
          return this.$t(this.backndfieldToInvalidMap[key][error_code]);
        case "Invalid_phone_number":
          return this.$t(this.backndfieldToInvalidMap[key][error_code]);
        case "ADDRESS_ALREADY_TAKEN":
          return this.$t(this.backndfieldToInvalidMap[key][error_code]);
        case "VALUES_SHOULD_MATCH":
          return this.$t(this.backndfieldToInvalidMap[key]);
        case "VALUE_SHOULD_BE_NUMBER":
          return this.$t(this.backndfieldToInvalidMap[key][error_code]);
        case "VALUE_SHOULD_BE_A_SAFE_NUMBER":
          return this.$tc("Comn_must_greater_than", 2, {
            field: fieldTranslation,
            threshold: this.backndfieldToInvalidMap[key]
              .VALUE_SHOULD_BE_A_SAFE_NUMBER,
          });
        case "PASSWORD_CONFIRM_PASSWORD_NOT_SAME":
          return this.$t("Password_confirm_password_not_match", {
            field: fieldTranslation,
          });
        case "INVALID_PASSWORD":
          return this.$t("Password_must_contain_at_least_6_Characters", {
            field: fieldTranslation,
          });
        case "WRONG_CURRENT_PASSWORD":
          return this.$t("Wrong_current_password", {
            field: fieldTranslation,
          });
        case "INVALID_USER_DATA":
          return this.$t("Usrs_email_already_in_use", {
            field: fieldTranslation,
          });
        default:
      }
    },
  },
};
export default errorKeyMapMixin;
